import React, { useState } from "react";
import AuthContext from "./context";
import AuthProviderWrapper from "./auth";
import { handleLogout } from "../pages/logout/logout";

export function AuthContextProvider({ children }) {
    const [user, setUser] = useState(null);
    const [accessToken, setAccessToken] = useState(null);

    const [refreshToken, setRefreshToken] = useState(
        localStorage.getItem("refresh_token")
    );
    const [deviceId, setDeviceId] = useState(localStorage.getItem("device-id"));
    const [isAuthenticated, setIsAuthenticated] = useState(!!refreshToken);
    // const [isAuthenticated, setIsAuthenticated] = useState(true);

    const logout = async () => {
        await handleLogout(accessToken);
        setIsAuthenticated(false);
        localStorage.removeItem("refresh_token");
        window.location.href = "/";
        // setUser({});
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                setUser,
                refreshToken,
                setRefreshToken,
                isAuthenticated,
                setIsAuthenticated,
                accessToken,
                setAccessToken,
                logout,
                deviceId,
            }}
        >
            <AuthProviderWrapper>{children}</AuthProviderWrapper>
        </AuthContext.Provider>
    );
}

export default function useAuth() {
    const context = React.useContext(AuthContext);

    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }

    return context;
}
